import React, { Fragment, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { useRouteMatch } from 'react-router-dom';
import { getInt } from 'utils/functions';
import { areas } from 'constants/areas';
import { Typography, IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { useReactiveVar } from '@apollo/client';
import { userNameVar } from '../variables';
import { ADMIN_USER_GROUPS_READ } from 'constants/rightsCodes';
import UserContainer from './UserContainer';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const userId = match.params.id && getInt(match.params.id);
  const { t } = useTranslation();
  const userName = useReactiveVar(userNameVar);

  const onRedirect = useCallback(
    id => {
      historyContext.push(`/users/${id}`);
    },
    [historyContext]
  );

  const title = useMemo(() => `${t('Users.Title')}: ${userName || '- / -'}`, [t, userName]);

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>
          {title}
        </Typography>
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <IconButton tooltip={t('BackToList')} color='transparent' onClick={() => historyContext.push(`/users`)}>
          <ArrowBack />
        </IconButton>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_USER_GROUPS_READ}>
        <UserContainer userId={userId} onRedirect={onRedirect} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
